<template>
  <BaseDialog ref="popup">
    <div class="content-ct">
      <h2 style="margin-top: 0">{{ title }}</h2>
      <p v-html="message"></p>
      <div class="form-field" v-if="withInput">
        <label>{{ inputLabel }}*</label>
        <textarea v-model="reasonModel"></textarea>
      </div>
      <div class="btns">
        <button class="action-btn cancel" @click="_cancel">{{ cancelButton }}</button>
        <button class="action-btn confirm" @click="_confirm" :disabled="withInput && !reasonModel">{{ okButton }}</button>
      </div>
    </div>
  </BaseDialog>
</template>

<script>
import BaseDialog from '../BaseDialog.vue'

export default {
  name: 'ConfirmDialog',

  components: { BaseDialog },

  data: () => ({
    // Parameters that change depending on the type of dialogue
    title: undefined,
    message: undefined, // Main text content
    okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
    cancelButton: 'Cancel', // text for cancel button
    withInput: false,
    inputLabel: 'Reason',
    reasonModel: '',

    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  methods: {
    show(opts = {}) {
      this.title = opts.title
      this.message = opts.message
      this.okButton = opts.okButton
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton
      }
      this.withInput = false
      console.log(opts)
      if (opts.withInput) {
        this.reasonModel = ''
        this.withInput = true
        if (opts.inputLabel) {
          this.inputLabel = opts.inputLabel
        }
      }
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open()
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    _confirm() {
      this.$refs.popup.close()
      if (this.withInput) {
        this.resolvePromise(this.reasonModel)
      } else {
        this.resolvePromise(true)
      }
    },

    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise(false)
      // Or you can throw an error
      // this.rejectPromise(new Error('User cancelled the dialogue'))
    },
  },
}
</script>

<style scoped>
.btns {
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.action-btn {
  padding: 0.5em 1em;
  border-radius: 5px;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
}
.confirm {
  background-color: #d5eae7;
  border: 2px solid #0ec5a4;
  color: #35907f !important;
}

.cancel {
  background-color: #ffc8c8;
  border: 2px solid #ef3a3a;
  color: #ef3a3a !important;
}
.form-field {
  margin-top: 18px;
}
.form-field textarea {
  margin-bottom: 0 !important;
}
.content-ct {
  min-width: 430px !important;
}
</style>
